export class UpdatePasswordError extends Error {
  constructor(message: string) {
    super(message);

    Object.setPrototypeOf(this, UpdatePasswordError.prototype);
  }
}
